export default "__VITE_ASSET__CTA9EelJ__"